import { Button, HorizontalSpacer, Image, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEventCard extends Layout {
    buttonClose: Button;
    horizontalspacerHeaderL: HorizontalSpacer;
    horizontalspacerHeaderLC: HorizontalSpacer;
    horizontalspacerHeaderR: HorizontalSpacer;
    horizontalspacerRC: HorizontalSpacer;
    imageCollapsedEventHeader: Image;
    imageEventHeader: Image;
    labelCollapsedHeaderTitle: Label;
    labelHeaderTitle: Label;
    panelCollapsed: Panel;
    panelDates: Panel;
    panelEvent: Panel;
    panelEventCardUpper: Panel;
    panelExtraTop: Panel;
    panelOverlapSpacer: Panel;
    textboxComments: Textbox;
    textboxDescription: Textbox;
    textboxDispatchAllowed: Textbox;
    textboxEndDate: Textbox;
    textboxFullCSZ: Textbox;
    textboxStartDate: Textbox;
    textboxStatus: Textbox;
}
